export { HotelHeaderComponent, HotelHeaderComponentEditable } from './HotelHeader';
